export const data = [
  {
    img: "https://creativeballoons.netlify.app/productImgs/Home-banner/Arche2b.jpg",
    key: "0",
    heading: "Arch's",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy",
    cta: "/product/2",
  },
  {
    img: "https://creativeballoons.netlify.app/productImgs/balloons/balloon8.jpg",
    key: "1",
    heading: "Balloons",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy",
    cta: "/product/39",
  },
  {
    img: "https://creativeballoons.netlify.app/productImgs/Home-banner/Costumes15.jpg",
    key: "2",
    heading: "Costumes",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy",
    cta: "/product/11",
  },
  {
    img: "https://creativeballoons.netlify.app/productImgs/Home-banner/Danglers1.jpg",
    key: "3",
    heading: "Danglers",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy",
    cta: "/product/14",
  },
  {
    img: "https://creativeballoons.netlify.app/productImgs/Home-banner/Inflatable.jpg",
    key: "4",
    heading: "Inflatables",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy",
    cta: "/product/72",
  },
  {
    img: "https://creativeballoons.netlify.app/productImgs/Home-banner/InflatableBounce1.jpg",
    key: "5",
    heading: "Inflatable Bounce",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy",
    cta: "/product/15",
  },
  {
    img: "https://creativeballoons.netlify.app/productImgs/Home-banner/Tent6b.jpg",
    key: "6",
    heading: "Tent's",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy",
    cta: "/product/22",
  },
  {
    img: "https://creativeballoons.netlify.app/productImgs/Home-banner/water_roller2b.jpg",
    key: "7",
    heading: "Water Roller",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy",
    cta: "/product/28",
  },
];
